<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {strParams} from 'shared/utils/pipes';
    import KpMarkdown from 'shared/components/kp-markdown/KpMarkdown.svelte';

    export let code: string;
    export let params: string[] = [];
    export let noMarkdown = false;

    const localize = getLocalization();
</script>

{#if noMarkdown}
    {pipe(localize(code), strParams(...params))}
{:else}
    <KpMarkdown markdown="{pipe(localize(code), strParams(...params))}"/>
{/if}